<div class="form-group">
  <label
    [for]="firstInputId$ | async"
    class="control-label"
    ngClass="col-xs-{{ labelWidth }}"
  >
    <ng-content select="[label]"></ng-content>
  </label>
  <div #content ngClass="col-xs-{{ contentWidth }}">
    <ng-content></ng-content>
  </div>
</div>
